import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Avatar } from "@mui/material";
import hoverLinkedin from "../../assets/linkedin-hover-gold.webp";
import { TeamButton } from "../../utils/theme.js";
import { useMediaQuery } from "@mui/material";
import { theme } from "../../utils/theme.js";

const AdvisorsWeb = (props) => {
  const { t } = useTranslation();

  const dimensionsLg = useMediaQuery(theme.breakpoints.down("lg"));
  const dimensionsXl = useMediaQuery(theme.breakpoints.down("xl"));
  const [linkedinHover, setLinkedinHover] = useState(null);

  const handleHoverIn = (name) => {
    setLinkedinHover(name);
  };

  const handleHoverOut = () => {
    setLinkedinHover(null);
  };

  return (
    <Grid
      container
      flexDirection="column"
      alignItems="center"
      mb={20}
      mt={-15}
      sx={{
        display: props.display,
      }}
    >
      <Typography variant="h2" mb={1.5}>
        {t("advisorsComponent.title")}
      </Typography>
      <Typography variant="h4" textAlign="center" mb={8}>
        {t("advisorsComponent.subTitle")}
      </Typography>
      <Grid container item md={10} columnSpacing={4} justifyContent="center">
        {props.advisors.map((member) => (
          <Grid
            container
            item
            md={2.4}
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            key={`member_${member.id}`}
          >
            <Avatar
              style={{
                width: "fit-content",
                height: "fit-content",
                backgroundColor: "#BADBF6",
              }}
            >
              <TeamButton
                onMouseMove={() => handleHoverIn(member.name)}
                onMouseLeave={handleHoverOut}
              >
                <a target="_blank" rel="noopener noreferrer" href={member.linkedin}>
                  {linkedinHover === member.name ? (
                    <img
                      src={hoverLinkedin}
                      style={{
                        width: dimensionsLg
                          ? "152px"
                          : dimensionsXl
                          ? "200px"
                          : "250px",
                      }}
                      height="auto"
                      alt="HovertoLinkedin"
                    ></img>
                  ) : (
                    <img
                      src={member.image}
                      style={{
                        width: dimensionsLg
                          ? "152px"
                          : dimensionsXl
                          ? "200px"
                          : "250px",
                      }}
                      height="auto"
                      alt={member.name}
                    ></img>
                  )}
                </a>
              </TeamButton>
            </Avatar>
            <Grid item textAlign="center" mt={2.5}>
              <Typography variant="h4Bold">{member.name}</Typography>
              <Typography
                variant="h5"
                textAlign="center"
                color="#353945"
                mt={0.7}
              >
                {member.title}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
export default AdvisorsWeb;
